module.exports = __webpack_public_path__ + "img/5.b72777c0.png";